
export default class Worker {
	VAPID_PUBLIC_KEY = 'BDEPKIlfIBODoarEUhKiGI3a3e7dLOEIRMQHppkuK6W6Lb2i6o17YP8hTWgdiw9P0RfA8_G5rSviyqZrZ0_y_CY'

	async registerServiceWorker() {
		let worker = false;
		try {
			worker = await navigator.serviceWorker.register('/scripts/service-worker.js?v=3');
		} catch (error) {
			console.error(error);
		}
		return worker;
	}

	async unRegisterServiceWorker() {
		try {
			const worker = await navigator.serviceWorker.getRegistration('/scripts/service-worker');
			await worker.unregister();
		} catch (error) {
			console.error(error);
		}
	}

	async getPushSubscription(worker) {
		const subscribe = ((worker) => {
			return new Promise((resolve, reject) => {
				setTimeout(async () => {
					const subscription = await worker.pushManager.subscribe({
						userVisibleOnly: true,
						applicationServerKey: this.urlB64ToUint8Array(this.VAPID_PUBLIC_KEY)
					});

					resolve(subscription);
				}, 1500);
			});
		});

		const subscription = await subscribe(worker);

		return subscription
	}

	urlB64ToUint8Array(base64String) {
		const padding = '='.repeat((4 - base64String.length % 4) % 4);
		const base64 = (base64String + padding)
			.replace(/\-/g, '+')
			.replace(/_/g, '/');
		const rawData = window.atob(base64);
		const outputArray = new Uint8Array(rawData.length);
		for (let i = 0; i < rawData.length; ++i) {
			outputArray[i] = rawData.charCodeAt(i);
		}
		return outputArray;
	};

	async init() {
		let subscription = false;
		let worker = await navigator.serviceWorker.getRegistration('/scripts/service-worker');
		if(worker) {
			worker.update();
			await worker.pushManager.getSubscription();
		}

		if(!worker || Notification.permission != 'granted') {
			await Notification.requestPermission();
			worker = await this.registerServiceWorker();
		}

		if(worker)
			subscription = await this.getPushSubscription(worker);

		return subscription;
	}
}
